import jQuery from 'jquery';

;
(function($, window, document, undefined) {

	'use strict';

	// Create the defaults once
	var pluginName = 'equalHeaders',
		defaults = {
			headerClass: '.c-header'
		};

	// The actual plugin constructor
	function Plugin(element, options) {
		this.pluginName = pluginName;
		this.element = element;
		this.$element = $(element);

		this.options = $.extend({}, defaults, options);
		this._defaults = defaults;

		this.init();
	}

	Plugin.prototype.init = function () {		
		this._conformHeaders();
		this._initEvents();
	};

	Plugin.prototype._initEvents = function() {
		$(window).on('resize', { plugin: this }, throttle(250, this._conformHeadersOnResize));
	};

	Plugin.prototype._setConformingHeight = function (header, newHeight) {
		// set the height to something new, but remember the original height in case things change
		header.data("originalHeight", (header.data("originalHeight") == undefined) ? (header.height()) : (header.data("originalHeight")));
		header.height(newHeight);
	};

	Plugin.prototype._getOriginalHeight = function (header) {
		// if the height has changed, send the originalHeight
		return (header.data("originalHeight") == undefined) ? (header.height()) : (header.data("originalHeight"));
	};

	Plugin.prototype._conformHeadersOnResize = function (e) {
		if (!e || !e.data || !e.data.plugin) {
			return;
		}
		var plugin = e.data.plugin;		
		plugin._conformHeaders();
	}

	Plugin.prototype._conformHeaders = function() {
		var plugin = this;
		var $headers = this.$element.find(this.options.headerClass);
		if ($headers.length < 2) { return; }

		var currentTallest = 0,
			currentRowStart = 0,
			rowHeaders = new Array();

		$headers.each(function () {
			// "caching"
			var $el = $(this);
			var topPosition = $el.position().top;

			if (currentRowStart != topPosition) {
				// we just came to a new row.  Set all the heights on the completed row
				for (var currentHeader = 0; currentHeader < rowHeaders.length; currentHeader++) {
					plugin._setConformingHeight(rowHeaders[currentHeader], currentTallest);
				}

				// set the variables for the new row
				rowHeaders.length = 0; // empty the array
				currentRowStart = topPosition;
				currentTallest = plugin._getOriginalHeight($el);
				rowHeaders.push($el);

			} else {

				// another header on the current row.  Add it to the list and check if it's taller
				rowHeaders.push($el);
				currentTallest = (currentTallest < plugin._getOriginalHeight($el)) ? (plugin._getOriginalHeight($el)) : (currentTallest);
			}
		});

		// do the last row
		for (var currentHeader = 0; currentHeader < rowHeaders.length; currentHeader++) {
			plugin._setConformingHeight(rowHeaders[currentHeader], currentTallest);
		}
	};	

	$.fn[pluginName] = function(options) {
		return this.each(function() {
			if (!$.data(this,  pluginName)) {
				$.data(this, pluginName,
					new Plugin(this, options));
			}
		});
	};

})(jQuery, window, document);